// 导出配置的路由器
export default [{
    path: '/marketingCenter',
    component: () =>
        import ('@/layout/index'),
    redirect: 'marketingCenter/commission',
    meta: {
        title: '营销中心',
        icon: 'icon-yingxiao1',
        perms: ['bee:marketing']
    },
    children: [
        // {
        //     path: 'commission',
        //     component: () =>
        //         import ('@/module/marketingCenter/page/commission/manage.vue'),
        //     meta: {
        //         title: '佣金管理',
        //         icon: 'icon-huodong1',
        //         perms: ['bee:marketing:commission']
        //     }
        // },
        // {
        //     path: 'advertisingManagement',
        //     component: () =>
        //         import ('@/module/marketingCenter/page/advert/manage.vue'),
        //     meta: {
        //         icon: 'icon-guanggao',
        //         title: '广告管理',
        //         perms: ['bee:marketing:advert']
        //     }
        // },
        // {
        //     path: 'notice',
        //     component: () =>
        //         import ('@/module/marketingCenter/page/notice/manage.vue'),
        //     meta: {
        //         icon: 'icon-gonggao',
        //         title: '活动公告',
        //         perms: ['bee:marketing:notice']
        //     }
        // },
    /*    {
            path: 'couponManagement',
            component: () =>
                import ('@/module/marketingCenter/page/coupon/manage.vue'),
            meta: {
                icon: 'icon-youhui',
                title: '优惠券管理',
                perms: ['bee:marketing:coupon']
            }
        },*/
      {
        path: 'storeCardManagement',
        component: () =>
          import ('@/module/marketingCenter/page/storeCard/manage.vue'),
        meta: {
          icon: 'icon-qia1',
          title: '储值卡管理',
          perms: ['bee:marketing:storedCard']
        }
      },
    ]
}]



// WEBPACK FOOTER //
// ./src/module/marketingCenter/router/index.js